'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { initGA, pageview } from '@/slw/shared/lib/gtag';

interface GTagProviderProps {
    children: React.ReactNode;
}

export function GTagProvider({ children }: GTagProviderProps) {
    const pathname = usePathname();
    const [isGAInitialized, setIsGAInitialized] = useState(false);

    useEffect(() => {
        // Initialize Google Analytics with a small delay to ensure DOM is ready
        const timer = setTimeout(() => {
            try {
                initGA();
                setIsGAInitialized(true);
            } catch (error) {
                // Handle error silently
            }
        }, 500); // Increased delay to ensure everything is ready

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        // Track pageview on route change with delay
        if (pathname && isGAInitialized) {
            const timer = setTimeout(() => {
                try {
                    pageview(pathname);
                } catch (error) {
                    // Handle error silently
                }
            }, 1000); // Increased delay to ensure GA is ready

            return () => clearTimeout(timer);
        }
    }, [pathname, isGAInitialized]);

    return <>{children}</>;
} 